<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div
            v-if="mostraErro"
            class="alert alert-danger alert-dismissible col-12"
            role="alert"
          >
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <strong>Ops!</strong>
            <span>{{ mensagemErro }}</span>
          </div>
        </div>
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-info"></i>Dados do contratante</h2>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Nome</label>
                <input
                  v-model="user.name"
                  class="form-control"
                  placeholder="Nome"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Sobrenome</label>
                <input
                  v-model="user.last_name"
                  class="form-control"
                  placeholder="Sobrenome"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>E-mail / Login</label>
                <input
                  v-model="user.email"
                  class="form-control"
                  placeholder="E-mail"
                  v-on:blur="preencheLogin"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Telefone</label>
                <input
                  class="form-control"
                  v-mask="'(##) 9####-####'"
                  type="tel"
                  v-model="phones"
                  @blur="
                    (e) => {
                      if (e.target.value.split(' ')[1]) {
                        user.phones.number = e.target.value
                          .split(' ')[1]
                          .replace('-', '');
                        user.phones.area_code = e.target.value
                          .split(' ')[0]
                          .replace(/[^0-9]/g, '');
                      } else if (e.target.value === '') {
                        user.phones.number = '';
                        user.phones.area_code = '';
                      }
                    }
                  "
                  placeholder="Telefone"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>CPF</label>
                <input
                  class="form-control"
                  inputmode="numeric"
                  v-mask="'###.###.###-##'"
                  v-model="cpf"
                  @blur="
                    (e) => (user.cpf = e.target.value.replace(/[^0-9]/g, ''))
                  "
                  placeholder="CPF"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Senha</label>
                <div class="inputContainer">
                  <input
                    class="form-control"
                    :type="inputPasswordType"
                    name="password"
                    v-model="user.password"
                    placeholder="Senha"
                    autocomplete="new-password"
                    required
                  />
                  <i v-if="isLocked" class="fa fa-lock inputIcon" @click="changeIconPassword"></i>
                  <i v-else class="fa fa-unlock inputIcon" @click="changeIconPassword"></i>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Criar usuário com acesso/e-mail válido?</label>
                <div class="flex checkboxContainer">
                  <label for="isVerified" class="mr-3 flex align-items-center">
                    <input id="isVerified" type="radio" v-model="user.verified_at" value="1" class="mr-2" />
                    Sim
                  </label>
                  <label for="notVerified" class="ml-3 flex align-items-center">
                    <input id="notVerified" type="radio" v-model="user.verified_at" value="0" class="mr-2" />
                    Não
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-map-marker"></i>Endereço do contratante</h2>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>CEP</label>
                <input
                  v-model="zip_code"
                  v-mask="'#####-###'"
                  @blur="(e) => getAddress(e.target.value)"
                  class="form-control"
                  type="tel"
                  placeholder="CEP"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Cidade</label>
                <input
                  v-model="user.city"
                  class="form-control"
                  readonly
                  placeholder="Cidade"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Estado</label>
                <input
                  v-model="user.state"
                  class="form-control"
                  readonly
                  placeholder="Estado"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Bairro</label>
                <input
                  v-model="user.district"
                  class="form-control"
                  placeholder="Bairro"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Rua</label>
                <input
                  v-model="user.street"
                  class="form-control"
                  placeholder="Rua"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Número</label>
                <input
                  class="form-control"
                  type="number"
                  v-model="user.street_number"
                  placeholder="N.º"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Complemento</label>
                <input
                  v-model="user.complement"
                  class="form-control"
                  placeholder="Complemento"
                />
              </div>
            </div>
            <!-- <div class="col-md-2">
              <div class="form-group">
                <label>Naturalidade</label>
                <input
                  v-model="user.naturalidade"
                  class="form-control"
                  placeholder="naturalidade"
                />
              </div>
            </div> -->
          </div>
          <!-- <div class="row mb-3">
            <div class="col-md-5"> -->
              <!-- <div class="form-group">
                <label>Planos</label>
                <input @change="e => addPlan(e)" class="form-control" list="plans" />
                <datalist id="plans">
                  <template v-for="plano in planos">
                    <option v-if="user.plans.find(item => item.id == plano.id) ? false : true" :key="plano.id" :id="plano.id" :value="`${plano.id} - ${plano.name}`" />
                  </template>
                </datalist>
                <select id="plans" @change="e => addPlan(e)" class="form-control">
                  <template v-for="plano in planos">
                    <option value="" selected disabled hidden v-bind:key="plano.name">Escolha um plano</option>
                    <option v-if="user.plans.find(item => item.id == plano.id) ? false : true" :key="plano.id" :id="plano.id" :value="`${plano.id} - ${plano.name}`">
                      {{`${plano.id} - ${plano.name}`}}
                    </option>
                  </template>
                </select>
              </div> -->

              <!-- <template v-if="user.plans.length > 0">
               <label>Planos Selecionados:</label>
                <div class="list_plans">
                <template v-for="plano in user.plans">
                  <div class="item" v-if="planos.length > 0" :key="plano.id">
                
                    <img :src="planos.find((item) => item.id == plano.id).foto_plano"/>
                    <div class="container-nameCount">
                      <span class="name">
                        <b>{{
                          planos.find((item) => item.id == plano.id).name
                        }}</b>
                      </span>
                      <div class="counter">
                        <div class="op" @click="subPlan(plano)"><i>-</i></div>
                        <span class="quant">{{ plano.qtd }}</span>
                        <div class="op" @click="sumPlan(plano)"><i>+</i></div>
                      </div>
                    </div>

                  </div>
                </template>
              </div>
              </template> -->
            <!-- </div>
          </div> -->
          
        </div>
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-users"></i>Participantes</h2>
          </div>

          <template v-for="(participante, index) in participantes">
            <div :key="index">
              <p class="flex justify-content-between cursor-pointer">
                <b class="badge-item">Participante {{ index + 1 }} </b>
                <i
                  @click="() => deletarParticipante(index)"
                  class="fa fa-times badge-item"
                ></i>
              </p>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Nome</label>
                    <input
                      v-model="participantes[index].name"
                      class="form-control"
                      placeholder="Nome"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Data de nascimento</label>
                    <input
                      class="form-control"
                      v-mask="'##/##/####'"
                      placeholder="Nascimento"
                      v-model="participantes[index].birth_date"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>RG (Não obrigatório)</label>
                    <input
                      v-model="participantes[index].rg"
                      class="form-control"
                      type="tel"
                      placeholder="RG"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>CPF</label>
                    <input
                      class="form-control"
                      type="tel"
                      v-mask="'###.###.###-##'"
                      v-model="participantes[index].cpf"
                      @blur="
                        (e) =>
                          (participantes[index].cpf = e.target.value.replace(
                            /[^0-9]/g,
                            ''
                          ))
                      "
                      placeholder="CPF"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>CNS (Não obrigatório)</label>
                    <input
                      class="form-control"
                      placeholder="CNS"
                      v-model="participantes[index].cns"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>E-mail</label>
                    <input
                      class="form-control"
                      type="email"
                      v-model="participantes[index].email"
                      placeholder="E-mail"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Naturalidade (Não obrigatório)</label>
                    <input
                      class="form-control"
                      v-model="participantes[index].naturalidade"
                      placeholder="Ex: Poços de Caldas"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Planos</label>
                    <select 
                      id="plans" 
                      class="form-control"
                      v-model="participantes[index].plan_id"
                      @change="atualizarCarrinhoComParticipantes"
                    >
                      <option :value="0" selected hidden disabled>Escolha um plano</option>
                      <template v-for="plano in planosEscolher">
                        <option :key="plano.id" :id="plano.id" :value="plano.id">
                          {{`${plano.id} - ${plano.name}`}}
                        </option>
                      </template>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Nome da mãe</label>
                    <input
                      class="form-control"
                      placeholder="Nome da mãe"
                      v-model="participantes[index].nome_mae"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Estado Civil</label>
                    <select class="form-control" v-model="participantes[index].estado_civil">
                      <option value="" selected disabled>Selecione o estado civil</option>
                      <option value="Amasiado">Amasiado</option>
                      <option value="Casado">Casado</option>
                      <option value="Convivente">Convivente</option>
                      <option value="Desquitado">Desquitado</option>
                      <option value="Divorciado">Divorciado</option>
                      <option value="Separado">Separado</option>
                      <option value="Solteiro">Solteiro</option>
                      <option value="Viúvo">Viúvo</option>
                      <option value="Outros">Outros</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Gênero</label>
                    <select class="form-control" v-model="participantes[index].genero">
                      <option value="" selected disabled>Selecione o gênero</option>
                      <option value="Feminino">Feminino</option>
                      <option value="Masculino">Masculino</option>
                      <option value="Outros">Outros</option>
                    </select>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label>Parentesco</label>
                    <select
                      v-model="participantes[index].parentesco"
                      class="form-control"
                      @change="handleResponsavelChange(index)"
                    >
                      <option value="" disabled selected>Selecione o parentesco</option>
                      <option value="Nenhum, sou responsável financeiro">
                        Nenhum, sou responsável financeiro
                      </option>
                      <option value="Cônjuge">Cônjuge</option>
                      <option
                        value="Convivente, sem eventual concorrência com o cônjuge, salvo por decisão judicial"
                      >
                        Convivente, sem eventual concorrência com o cônjuge,
                        salvo por decisão judicial
                      </option>
                      <option
                        value="Filhos solteiro, até 21 anos incompletos, ou até 24 anos incompletos, desde que cursando graduação em nível superior de ensino"
                      >
                      Filhos solteiro, até 21 anos incompletos, ou até 24 anos incompletos, desde que cursando graduação em nível superior de ensino
                      </option>
                      <option
                        value="Enteado, o menor sob a guarda por força de decisão judicial e o menor tutelado, que ficam equiparados aos filhos"
                      >
                        Enteado, o menor sob a guarda por força de decisão
                        judicial e o menor tutelado, que ficam equiparados aos
                        filhos
                      </option>
                      <option
                        value="Neto(a)/bisneto(a)"
                      >
                      Neto(a)/bisneto(a)
                      </option>
                      <option value="Irmão(ã)">
                        Irmão(ã)
                      </option>
                      <option value="Pais">
                        Pais, avós e bisavós
                      </option>
                      <option value="Tio(a)">
                        Tio(a)
                      </option>
                      <option value="Sogro(a)">
                        Sogro(a)
                      </option>
                      <option value="Genro/nora">
                        Genro/nora
                      </option>
                      <option value="Cunhado(a)">
                        Cunhado(a)
                      </option>
                      <option value="Padrasto/madrasta">
                        Padrasto/madrasta
                      </option>
                      <option value="Sobrinho(a)">
                        Sobrinho(a)
                      </option>
                      <!-- <option value="Pais">Pais</option>
                      <option value="Sogros">Sogros</option> -->
                    </select>
                  </div>
                </div>
                <div>

                </div>
              </div>
              <hr />
            </div>
          </template>

          <div class="row">
            <div class="btnContainer col-md-12 flex align-items-center justify-content-between mt-5">
        
              <button
                href="#0"
                class="btnCustom btn_1 medium col-md-4 btn-color flex align-items-center justify-content-center"
                @click="addParticipante"
              >
                Adicionar participante <i class="fa fa-plus ml-3"></i>
              </button>
              
            </div>
          </div>
        </div>

<!--         <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-money"></i>Valores dos Planos</h2>
          </div>
          <div class="row">
            <div class="table-responsive col-12">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Plano</th>
                    <th>Quantidade</th>
                    <th>Valor Mensal</th>
                    <th>Taxa de Adesão</th>
                    <th>Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(plan, index) in shoppingCar.plans" :key="plan.id">
                    <td>{{ plan.name }}</td>
                    <td>{{ plan.qtd }}</td>
                    <td>
                      <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                          <span class="input-group-text">R$</span>
                        </div>
                        <input
                          type="number"
                          class="form-control"
                          :value="(plan.price / 100).toFixed(2)"
                          @input="plan.price = Math.round($event.target.value * 100)"
                          @change="updateTotal_Subtotal_Adesao"
                          step="0.01"
                          min="0"
                        />
                      </div>
                    </td>

                    <td>
                      <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                          <span class="input-group-text">R$</span>
                        </div>
                        <input
                          type="number"
                          class="form-control"
                          :value="(plan.adesao / 100).toFixed(2)"
                          @input="plan.adesao = Math.round($event.target.value * 100)"
                          @change="updateTotal_Subtotal_Adesao"
                          step="0.01"
                          min="0"
                        />
                      </div>
                    </td>

                    <td>
                      R$ {{ (((plan.price * plan.qtd) + plan.adesao) / 100).toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> -->

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-usd"></i>Dados de pagamento</h2>
          </div>
          <div class="flex flex-wrap align-items-start justify-content-between">
<!--             <div class="col-md-6">
              <div class="row">
               <div class="col-md-12">
                  <div class="form-group">
                    <label>CPF do portador</label>
                    <input
                      class="form-control"
                      type="tel"
                      v-mask="'###.###.###-##'"
                      placeholder="CPF"
                      v-model="checkout.billing_info.credit_card.cpf"
                      @blur="
                        (e) =>
                          (checkout.billing_info.credit_card.cpf = e.target.value.replace(/[^0-9]/g, ''))
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Número do cartão de crédito</label>
                    <input
                      class="form-control"
                      v-model="checkout.billing_info.credit_card.number"
                      v-mask="'#### #### #### ####'"
                      @change="(e) => checkout.billing_info.credit_card.number =  e.target.value.replace(' ', '')"
                      type="text"
                      placeholder="Número"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Nome presente no cartão de crédito</label>
                    <input
                      v-model="checkout.billing_info.credit_card.holder_name"
                      class="form-control"
                      placeholder="Nome"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>CVV</label>
                    <input
                      class="form-control"
                      v-mask="'###'"
                      v-model="checkout.billing_info.credit_card.cvv"
                      type="text"
                      placeholder="CVV"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Validade</label>
                    <input
                      class="form-control"
                      type="tel"
                      v-mask="'##/##'"
                      @blur="
                        (e) => {
                          if (e.target.value.split('/')[0]) {
                            checkout.billing_info.credit_card.expiration_month = e.target.value.split(
                              '/'
                            )[0];
                            checkout.billing_info.credit_card.expiration_year = e.target.value.split(
                              '/'
                            )[1];
                          }
                        }
                      "
                      placeholder="MM/AA"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label>Cupom de desconto</label>
                  <input
                    type="text"
                    v-model="cupom"
                    @blur="validaCupom"
                    class="form-control text-uppercase"
                    :class="cupom_class"
                  />
                  <div v-if="tem_cupom" class="mt-2">
                    <span
                        class="msg-erro"
                        v-if="!cupom_valido"
                      >*Cupom inválido
                    </span>

                    <span
                        class="msg-success"
                        v-else
                      >{{`*Cupom aplicado, a primeira mensalidade será no valor de R$ ${valor_cupom}`}}
                      </span>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="col-md-5">
              <ShoppingCarDetails :shoppingCar="shoppingCar"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <p>
              <button href="#0" @click="criarAssinatura('Salvar')" class="btn_1 medium pull-right mb-5">
                Salvar
              </button>
            </p>
          </div>
<!--           <div class="col-md-12">
            <p>
              <button href="#0" @click="criarAssinatura('Finalizar')" class="btn_1 medium pull-right mb-5">
                Finalizar
              </button>
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import funcoesGerais from "@/assets/js/funcoes.js";
import { toTimeStamp } from "@/utils/formater";
import axios from "axios";
import VueApexCharts from "vue-apexcharts";
import { isEmail, isName } from "@/utils/validate";
import { cpf } from 'cpf-cnpj-validator';
import { ajax } from '@/utils/util'
import ShoppingCarDetails from '../../../components/ShoppingCarDetails.vue';

export default {
  components: {
    apexcharts: VueApexCharts,
    ShoppingCarDetails,
  },
  mixins: [funcoesGerais],
  data: function () {
    return {
      isLoading: false,
      isLocked: true,
      subscriptionData: null,
      inputPasswordType: "password",
      phones: "",
      cpf: "",
      shoppingCar: {
        plans: [],
        total: 0,
        subtotal: 0,
        adesao: 0,
      },
      titularPlan: null,
      participantes: [],
      planosEscolher: [],
      providerId: null,
      cupom: '',
      tem_cupom: false,
      cupom_valido: false,
      valor_cupom: null,
      cupom_class: '',
      checkout: {
        cupom: null,
        billing_info: {
          credit_card: {
            holder_name: "",
            cpf: "",
            number: "",
            bandeira: "",
            cvv: "",
            expiration_month: "",
            expiration_year: "",
          },
        },
      },
      zip_code: "",
      user: {
        phones: {
          number: "",
          area_code: "",
        },
        name: "",
        last_name: "",
        email: "",
        login: "",
        password: "",
        street: "",
        street_number: "",
        naturalidade: "",
        complement: "",
        district: "",
        zip_code: "",
        city: "",
        cpf: "",
        state: "",
        country: "",
        plans: [],
        verified_at: "1"
      },
      planos: [],
      dashboard: {
        assinantes: 0,
        vendas: 0
      },
    };
  },
  watch: {
    participantes: {
      handler(newVal) {
        //console.log('Participantes mudaram:', newVal);
        this.atualizarCarrinhoComParticipantes();
      },
      deep: true
    }
  },
  mounted() {
    this.isLoading = true;
    const subscriptionId = this.$route.params.id;
    
    if (!subscriptionId) {
        this.$swal('Erro', 'ID da assinatura não encontrado', 'error');
        return;
    }
    
    //console.log('Fetching subscription data for ID:', subscriptionId);
    
    ajax('get', `assinantes/${subscriptionId}/dados_completos`)
        .then(response => {
            //console.log('API Response:', response);
            
            if (response && response.subscription) {
                const sub = response.subscription;
                this.subscriptionData = sub;
                
                // Mapear dados do assinante
                if (sub.subscriber && sub.subscriber.user) {
                    this.user = {
                        ...this.user,
                        name: sub.subscriber.user.name || '',
                        last_name: sub.subscriber.user.last_name || '',
                        email: sub.subscriber.user.email || '',
                        login: sub.subscriber.user.email || '',
                        cpf: sub.subscriber.cpf || '',
                        street: sub.subscriber.street || '',
                        street_number: sub.subscriber.street_number || '',
                        complement: sub.subscriber.complement || '',
                        district: sub.subscriber.district || '',
                        city: sub.subscriber.city || '',
                        state: sub.subscriber.state || '',
                        zip_code: sub.subscriber.zip_code || '',
                        phones: {
                            number: (sub.phone && sub.phone.number) || '',
                            area_code: (sub.phone && sub.phone.area_code) || ''
                        }
                    };
                    this.providerId = sub.plan ? sub.plan.provider_id : null;
                    
                    // Inicializar plano titular e carrinho
                    if (sub.plan) {
                      console.log('Plano titular encontrado:', sub.plan);
                      this.titularPlan = {
                        id: sub.plan.id,
                        name: sub.plan.name || '',
                        price: sub.plan.price || 0,
                        qtd: 1,
                        cidade: sub.plan.provider.end_cidade || '',
                        estado: sub.plan.provider.end_estado || '',
                        adesao: sub.plan.setup_fee || 0,
                        tipo_desconto: sub.plan.tipo_desconto || '',
                        valor_desconto: sub.plan.valor_desconto || 0,
                      };
                      // garantir reatividade substituindo o array
                      this.shoppingCar.plans.splice(0, this.shoppingCar.plans.length, this.titularPlan);
                      this.updateTotal_Subtotal_Adesao();
                    }
                    
                    this.getPlanosEscolher()
                      .then(() => {
                        this.participantes = sub.dependentes || [];
                        this.participantes = this.participantes.map(p => {
                          if (p.birth_date) {
                            p.birth_date = p.birth_date.split('-').reverse().join('/');
                          }
                          return p;
                        });
                        // atualizar o carrinho com os participantes e seus planos após carregar os planos
                        this.$nextTick(() => {
                          this.atualizarCarrinhoComParticipantes();
                        });
                      })
                      .catch(e => {
                        console.error('Erro ao carregar planos:', e);
                        this.participantes = sub.dependentes || [];
                        this.participantes = this.participantes.map(p => {
                          if (p.birth_date) {
                            p.birth_date = p.birth_date.split('-').reverse().join('/');
                          }
                          return p;
                        });
                      });
                    // Update formatted CPF for display
                    this.cpf = sub.subscriber.cpf ? 
                        sub.subscriber.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : '';
                    
                    // Update formatted phone for display
                    if (sub.phone) {
                        this.phones = `(${sub.phone.area_code}) ${sub.phone.number}`;
                    }
                    
                    // Update formatted zip code for display
                    this.zip_code = sub.subscriber.zip_code || '';
                }
                
                // Mapear dados do cartão se existirem
/*                 if (sub.card) {
                  this.checkout.billing_info.credit_card = {
                      ...this.checkout.billing_info.credit_card, // Mantém outros campos existentes
                      
                      // Mapeia o CPF do portador (usando o campo 'cpf' do objeto 'card')
                      cpf: sub.card.cpf || '',
                      
                      // Mapeia o nome impresso no cartão
                      holder_name: sub.card.holder_name || '',
                      
                      // O número do cartão geralmente vem mascarado da API por segurança (ex: **** **** **** 1234)
                      // Se você precisar exibir apenas para conferência:
                      number: sub.card.number || ''
                  };
                } */
                
                this.isLoading = false;
            } else {
                console.error('Unexpected response format:', response);
                throw new Error('Formato de resposta inesperado da API');
            }
        })
        .catch(error => {
            console.error('Erro ao carregar dados da assinatura:', {
                error: error,
                message: error.message,
                response: error.response && error.response.data
            });
            this.$swal(
                'Erro', 
                error.message || 'Não foi possível carregar os dados da assinatura', 
                'error'
            );
            this.isLoading = false;
        });
    },
  methods: {
    getPlanosEscolher(){
      return new Promise((resolve, reject) => {
        this.isLoading = true;
        ajax('get', `operadoras/${this.providerId}/planos/adm`)
          .then(res => {
            this.planosEscolher = res.data;
            this.isLoading = false;
            resolve(res.data);
          })
          .catch(e => {
            console.error('Erro ao carregar planos:', e);
            this.isLoading = false;
            reject(e);
          });
      });
    },
    parseJwt(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },

    send(){
      this.isLoading = true;
      var checkFields = this.isEmpty(this.user);
      if (checkFields.length > 0) {
        this.isLoading = false;
        this.$swal.fire({
            position: "center",
            type: "error",
            title: "Os campos abaixo ainda precisam ser preenchidos!",
            html: checkFields,
            showConfirmButton: true,
          });
      } else {
        const emailValidate = isEmail(this.user.email);
        const nameValidate = isName(this.user.name);
        const lastNameValidate = isName(this.user.last_name);
        const cpfValidate = cpf.isValid(this.user.cpf);
        const telValidate = this.user.phones.number.length === 9;
        
        if (emailValidate && nameValidate && lastNameValidate && cpfValidate && telValidate) {
          if (this.user.verified_at === "1") {
            const currentDate = new Date().toLocaleDateString('pt-BR');
            this.user.verified_at = toTimeStamp(currentDate);
          } else {
            this.user.verified_at = null;
          }
          
          axios.post('store_user_por_corretor', this.user).then(res => {
            let token = res.data.token;
            let token_ajustado = this.parseJwt(token);
            let sub_id = token_ajustado.usr.sub_id;

            this.$swal.fire({
                position: "center",
                type: "success",
                title: "Cadastrado com sucesso!",
                showConfirmButton: true,
            });
            this.isLoading = false;
            const routeData = this.$router.resolve({name: 'DetalheOportunidade', params: {id: `${sub_id}`}});
            this.cpf = "";
            this.phones = "";
            this.zip_code = "";
            this.user = {
              phones: {
                number: "",
                area_code: "",
              },
              name: "",
              last_name: "",
              email: "",
              login: "",
              password: "",
              street: "",
              street_number: "",
              naturalidade: "",
              complement: "",
              district: "",
              zip_code: "",
              city: "",
              cpf: "",
              state: "",
              country: "",
              plans: [],
              verified_at: "1"
            }
            window.open(routeData.href, '_blank');
            //this.$router.replace(this.$route.query.redirect || `/corretor/oportunidades/detalhes/${sub_id}`);
          }).catch(e => {
            this.user.verified_at = this.user.verified_at ? '1' : '0';
            let responseError = e.response.data.message;
            if (responseError.includes("cpf")){
              this.$swal.fire({
                position: "center",
                type: "error",
                title: "CPF já cadastrado!",
                showConfirmButton: true,
              });
            } else{
              this.$swal.fire({
                position: "center",
                type: "error",
                title: "Erro ao realizar cadastro!",
                text: responseError,
                showConfirmButton: true,
              });
            }
            this.isLoading = false;
          })
        } else {
          let text = "";
          if (!emailValidate) text = 'Por favor, digite um email válido!'
          else if (!cpfValidate) text = 'Por favor, digite um CPF válido!'
          else if (!telValidate) text = 'Por favor, digite um telefone válido!'
          else if (!nameValidate || !lastNameValidate) text = 'Nome e Sobrenome não devem conter números ou caracteres especiais!'
          
          this.$swal.fire({
            position: "center",
            type: "warning",
            title: "Aviso",
            text,
            showConfirmButton: true,
          });
          this.isLoading = false;
        }
      }
    },
    changeIconPassword() {
      this.isLocked = !this.isLocked;
      this.inputPasswordType = this.isLocked ? "password" : "text";
      
    },
    addPlan(e){
      this.user.plans.push({id: e.target.value.split('-')[0], qtd: 1})
      e.target.value = ""
    },
    subPlan(plan){
      if(plan.qtd > 1){
        this.user.plans.find(item => item.id == plan.id).qtd--;
      }else{
        this.user.plans = this.user.plans.filter(item => item.id != plan.id)
      }
    },
    sumPlan(plan){
      this.user.plans.find(item => item.id == plan.id).qtd++;
    },
    getAddress(code) {
      if (code.length > 8) {
        this.isLoading = true;
        fetch(`https://viacep.com.br/ws/${code}/json/`)
          .then((res) => res.json())
          .then((res) => {
            this.user.zip_code = res.cep.replace(/[^0-9]/g, '');
            this.user.city = res.localidade;
            this.user.country = "BRA";
            this.user.district = res.bairro;
            this.user.state = res.uf;
            this.user.street = res.logradouro;
          })
          .catch( (e) => {
            this.zip_code = "";
            this.user.zip_code = "";
            this.user.city = "";
            this.user.district = "";
            this.user.state = "";
            this.user.street = "";
            this.user.street_number = "";
            this.user.complement = "";
            this.$swal.fire({
              position: "center",
              type: "error",
              title: "Erro",
              text: 'Por favor, insira um CEP válido.',
              showConfirmButton: true,
            });
          })
        this.isLoading = false;
      } else {
        if (code.length > 0) {
          this.$swal.fire({
            position: "center",
            type: "warning",
            title: "Aviso",
            text: "Digite um CEP válido.",
            showConfirmButton: true,
          });
        }
        this.zip_code = '';
        this.user.city = '';
        this.user.district = '';
        this.user.state = '';
        this.user.street = '';
        this.user.street_number = '';
        this.user.complement = '';
      }
    },
    preencheLogin(){
      let self = this;
      self.user.login = self.user.email;
    },
    isEmpty(fields) {
      const emptyFields = [];
      Object.entries(fields).forEach(element => {
          if (element[0] === 'phones') {
            Object.entries(fields.phones).forEach(el => {
              if(el[1] === ""){
                emptyFields.push(el[0])
              }
            })
          } else if (element[0] === 'verified_at') {
            if(element[1] === ""){
              emptyFields.push(element[0])
            }
          } else {
            if(element[1] === "" || element[1] === '0'){
              emptyFields.push(element[0])
            }
          }
      });
      let returnMessage = ""
      emptyFields.forEach(el => {
          el == 'password' ? el = 'Senha' : el;
          el == 'name' ? el = 'Nome' : el;
          el == 'last_name' ? el = 'Sobrenome' : el;
          el == 'street' ? el = 'Rua' : el;
          el == 'district' ? el = 'Bairro' : el;
          el == 'zip_code' ? el = 'CEP' : el;
          el == 'cpf' ? el = 'CPF' : el;
          el == 'login' ? el = 'Login' : el;
          el == 'email' ? el = 'Email' : el;
          el == 'street_number' ? el = 'Número' : el;
          el == 'number' ? el = 'Telefone' : el;
          //returnMessage += `* O campo <b>${el}</b> está vazio <br/>`
          if (el != 'city' && el != 'state' && el != 'country' && el != 'naturalidade' && el != 'complement' && el != 'area_code')
           returnMessage += '<b>* ' + el + '</b><br>'
      })
      if (!fields.cpf || fields.cpf === '') {
        returnMessage += '<b>* CPF</b><br>'
      }
      return returnMessage;
    },
    addParticipante() {
      this.participantes.push({
        plan_id: "",
        name: "",
        birth_date: "",
        cpf: "",
        rg: "",
        email: "",
        parentesco: "",
        nome_mae: "",
        estado_civil: "",
        genero: "",
        cns: "",
        naturalidade: "",
      });
    },
    deletarParticipante(i) {
      this.isLoading = true;
      if (this.participantes.length > 1) {
        let dependente = this.participantes[i];
        
        this.participantes.splice(i, 1);
        this.qtdParticipantes = this.participantes.length;
        
        if (dependente.plan_id) {
          const index = this.shoppingCar.plans.findIndex(plan => plan.id === dependente.plan_id);
          if (index !== -1) {
            if (this.shoppingCar.plans[index].qtd > 1) {
              this.shoppingCar.plans[index].qtd -= 1;
            } else {
              this.shoppingCar.plans.splice(index, 1);
            }
            this.updateTotal_Subtotal_Adesao();
          }
        }

        this.$swal.fire({
          position: "center",
          type: "success",
          title: "Sucesso",
          text: 'Participante removido com sucesso.',
          showConfirmButton: true,
        });
        this.isLoading = false;
      } else {
        this.$swal.fire({
          position: "center",
          type: "error",
          title: "Erro",
          text: 'Participante não pôde ser deletado.',
          showConfirmButton: true
        });
        this.isLoading = false;
      }
    },
    isBirthday(dateString) {
      const regex = /^\d{2}\/\d{2}\/\d{4}$/;
      if (!regex.test(dateString)) return false;

      const [day, month, year] = dateString.split("/").map(Number);
      const date = new Date(year, month - 1, day);
      
      return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
    },
    isDate18orMoreYearsOld(day, month, year) {
      const today = new Date();
      
      let age = today.getFullYear() - year;
      
      const currentMonth = today.getMonth() + 1; 
      const currentDay = today.getDate();

      if (currentMonth < month || (currentMonth === month && currentDay < day)) {
        age--;
      }

      return age >= 18;
    },
    saveDependents() {
      if (this.participantes.length > 0) {
        const participantesSemCPF = this.participantes.filter(p => !p.cpf || p.cpf == '');
        if (participantesSemCPF.length > 0) {
          this.$swal.fire({
            position: "center",
            type: "error",
            title: "Erro ao salvar",
            text: "Por favor, preencha o CPF de todos os participantes.",
            showConfirmButton: true,
          });
          return;
        }

        let temMaior = false;
        let temData = null;
        const dateValidate = [];
        this.participantes.map((element, key) => {
          dateValidate.push(this.isBirthday(element.birth_date));
          if(element.birth_date !== '') {
            temData = true;
            var ano = parseInt(element.birth_date.split("/")[2]);
            var mes = parseInt(element.birth_date.split("/")[1]);
            var dia = parseInt(element.birth_date.split("/")[0]);
            if (this.isDate18orMoreYearsOld(dia,mes,ano)) temMaior = true;
          } else {
            temData = false;
          }
        });

        if(temData && dateValidate.every(date => date === true)) {
          this.atualizarCarrinhoComParticipantes();
          
          if (!temMaior) {
            this.$bvModal.show('modalTitular');
          } else {
            this.cadastrarDependenteComTitular(false);
          }
        } else {
          this.$swal.fire({
            position: "center",
            type: "error",
            title: "Erro ao salvar",
            text: "Por favor, verifique a data de nascimento e insira um valor válido.",
            showConfirmButton: true,
          });
        }
      } else {
        this.$swal.fire({
          position: "center",
          type: "error",
          title: "Erro ao salvar",
          text: "Nenhum participante foi adicionado anteriormente.",
          showConfirmButton: true,
        });
      }
    },
    atualizarCarrinhoComParticipantes() {
      const planosCount = {};

      // Conta quantos participantes escolheram cada plano
      this.participantes.forEach(({ plan_id }) => {
        const id = Number(plan_id);
        if (!id) return;
        planosCount[id] = (planosCount[id] || 0) + 1;
      });

      // Garante que o plano titular esteja presente com qtd mínima 1
/*       if (this.titularPlan && Number(this.titularPlan.id)) {
        const tid = Number(this.titularPlan.id);
        planosCount[tid] = Math.max(planosCount[tid] || 0, 1);
      } */

      // Monta o array de planos do carrinho com detalhes (name, price, adesao, qtd)
      const newPlans = Object.keys(planosCount).map(key => {
        const id = Number(key);
        const qtd = planosCount[id] || 0;

        // Procura detalhes no `planosEscolher` ou em `titularPlan`
        let found = this.planosEscolher.find(p => Number(p.id) === id) || null;
        if (!found && this.titularPlan && Number(this.titularPlan.id) === id) found = this.titularPlan;
        let adesaoUnitaria = 0;
        if (found) {
          adesaoUnitaria = found.setup_fee || found.adesao || 0;
        }
        const totalAdesao = adesaoUnitaria * qtd;
        console.log('Detalhes do plano encontrado para ID', id, ':', this.planosEscolher, found);
        return {
          id: id,
          name: found ? (found.name || '') : '',
          price: found ? (found.price || 0) : 0,
          adesao: totalAdesao,
          qtd: qtd,
          cidade: found.provider ? (found.provider.end_cidade || '') : '',
          estado: found.provider ? (found.provider.end_estado || '') : '',
          tipo_desconto: found ? (found.tipo_desconto || '') : '',
          valor_desconto: found ? (found.valor_desconto || 0) : 0,
        };
      });

      this.shoppingCar.plans.splice(0, this.shoppingCar.plans.length, ...newPlans);

      this.$nextTick(this.updateTotal_Subtotal_Adesao);
    },
    validaCupom() {
      if(this.cupom != ""){
        let array_planos = [];
        this.planos.map((pl) => {
          array_planos.push(pl.id);
        })
        let obj = {
          cupons: [this.cupom],
          plans: array_planos
        }
        let cupons = [this.cupom];
        axios.post('validar_cupons', obj)
        .then(response => {
          let resposta = response.data;
          this.tem_cupom = true;
          if(resposta.cupons[0].valido) {
            this.$swal.fire({
              position: "center",
              type: "success",
              title: "Cupom Válido",
              text: "O cupom será aplicado na mensalidade do primeiro mês",
              showConfirmButton: true,
            });
            this.valor_cupom = resposta.valor;
            this.cupom_valido = this.cupom;
            this.cupom_class = 'success-class'
            this.updateTotal_Subtotal_Adesao();
          } else {
            this.$swal.fire({
              position: "center",
              type: "error",
              title: "Atenção",
              text: resposta.mensagem ? resposta.mensagem : 'Cupom Inválido',
              showConfirmButton: true,
            });
            this.cupom = '';
            this.cupom_valido = false,
            this.valor_cupom = 0;
            this.cupom_class = 'error-class'
            this.updateTotal_Subtotal_Adesao();
          }
        }).catch(() => {
        })
      }
    },
    updateTotal_Subtotal_Adesao() {
      console.log('Atualizando totais do carrinho:', this.shoppingCar);
      let total = 0;
      let totalAdesao = 0;
      let desconto = 0;
      
      this.shoppingCar.plans.forEach(plan => {
        const qtd = plan.qtd || 1;
        const price = plan.price || 0;
        const adesao = plan.adesao || 0;
        const cidade = plan.cidade || '';
        const estado = plan.estado || '';
        
        total += (price * qtd);
        totalAdesao += adesao;
      });
      
      this.$set(this.shoppingCar, 'total', total);
      this.$set(this.shoppingCar, 'adesao', totalAdesao);
      
      console.log('Totais atualizados:', {
        plans: this.shoppingCar.plans,
        total: this.shoppingCar.total,
        adesao: this.shoppingCar.adesao,
        desconto: this.shoppingCar.desconto,
        subtotal: this.shoppingCar.subtotal
      });
    },

    async criarAssinatura(dado) {
      this.isLoading = true;
      try {
        if(!this.user.password || this.user.password.length < 6){
          this.isLoading = false;
          this.$swal.fire({ position: 'center', type: 'error', title: 'Senha do usuário é obrigatório', showConfirmButton: true });
          return;
        }
        
        // Validar se o CPF do contratante está preenchido
        if(!this.user.cpf || this.user.cpf === ''){
          this.isLoading = false;
          this.$swal.fire({ position: 'center', type: 'error', title: 'CPF do contratante é obrigatório', showConfirmButton: true });
          return;
        }
        
        // Validar se todos os participantes têm CPF preenchido
        const participantesSemCPF = this.participantes.filter(p => !p.cpf || p.cpf === '');
        if (participantesSemCPF.length > 0) {
          this.isLoading = false;
          this.$swal.fire({ position: 'center', type: 'error', title: 'CPF dos participantes é obrigatório', text: 'Por favor, preencha o CPF de todos os participantes.', showConfirmButton: true });
          return;
        }
        
        this.atualizarCarrinhoComParticipantes();

        await this.$nextTick();

        const subscriberId = this.subscriptionData && this.subscriptionData.subscriber ? this.subscriptionData.subscriber.id : null;
        const titular = this.subscriptionData && this.subscriptionData.titular ? this.subscriptionData.titular : null;

        const dependents = (this.participantes || []).map(p => ({
          name: p.name || '',
          birth_date: p.birth_date || '',
          cpf: p.cpf || '',
          rg: p.rg || '',
          email: p.email || '',
          parentesco: p.parentesco || '',
          nome_mae: p.nome_mae || '',
          estado_civil: p.estado_civil || '',
          genero: p.genero || '',
          cns: p.cns || '',
          naturalidade: p.naturalidade || '',
          plan_id: p.plan_id ? parseInt(p.plan_id) : null,
          id: p.id || null,
          subscriber_id: p.subscriber_id || null
        }));

        const payload = {
          subscriber_id: subscriberId,
          user: this.user,
          titular: titular,
          dependents: dependents,
          carrinho: this.shoppingCar,
          billing_info: {
            ...this.checkout.billing_info,
            credit_card: {
              ...this.checkout.billing_info.credit_card,
              cpf: this.checkout.billing_info.credit_card.cpf.replace(/\D/g, ''),
              number: this.checkout.billing_info.credit_card.number.replace(/\s/g, '')
            }
          },
        };
        
        console.log('Payload para criação de assinatura:', payload);
        let res = null

        dado == 'Salvar' ? res = await axios.post('assinaturas/copia_dados', payload) : res = await axios.post('assinaturas/copia_assinatura', payload);

        if (res && res.data) {
          this.$swal.fire({ position: 'center', type: 'success', title: 'Dados salvos com sucesso! Usuário ja pode finalizar a compra...', showConfirmButton: true });

          if (res.data.dependents && Array.isArray(res.data.dependents)) {
            this.participantes = res.data.dependents.map(d => ({ ...d, plan_id: d.plan_id ? parseInt(d.plan_id) : d.plan_id }));
          }

        }

        this.isLoading = false;
        return res.data;
      } catch (e) {
        this.isLoading = false;
        console.error('Erro ao criar assinatura:', e);
        this.$swal.fire({ position: 'center', type: 'error', title: 'Erro ao criar assinatura', text: e.response && e.response.data ? (e.response.data.error || JSON.stringify(e.response.data)) : e.message, showConfirmButton: true });
        throw e;
      }
    },
    handleResponsavelChange(index) {
      const RESPONSAVEL_TEXT = 'Nenhum, sou responsável financeiro';
      const selected = this.participantes[index] && this.participantes[index].parentesco === RESPONSAVEL_TEXT;
      if (!selected) return;
      this.participantes.forEach((p, i) => {
        if (i !== index && p.parentesco === RESPONSAVEL_TEXT) {
          this.$set(this.participantes[i], 'parentesco', '');
        }
      });
    },

  }
};
</script>
<style scoped>
.list_plans{
  background-color: #f4f6fa;
  padding: 20px 10px;
  border-radius: 5px;
}

.counter{
  display: flex;
  justify-content: center;
  align-items: center;
}
.counter .op{
  width: 30px;
  height: 30px;
  border-radius: 5px;
  background-color: #af104c;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
}

.counter .quant{
  font-size: 25px;
  margin: 0px 10px;
  font-weight: bold;
  color: black;
}

.container-nameCount{
  display: flex;
  flex-flow: column;
  align-items: center;
}

.list_plans .item{
  background-color: white;
  border-radius: 5px;
  padding: 15px 10px;
  cursor: pointer;
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.056);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.item img{
  max-width: 90px;
  border-radius: 10px;
  margin-right: 10px;
}

.name{
  background-color: #af104c;
  color: white;
  padding: 2px 5px;
  margin-bottom: 10px;
  border-radius: 60px;
  font-size: 10px;
  text-align: center;
}

.inputContainer{
  position: relative;
}

.inputIcon{
  position: absolute;
  right: 1.2rem;
  top: .54rem;
  font-size: 1.25rem;
  user-select: none;
  cursor: pointer;
  padding: .2rem .4rem;
}

.checkboxContainer{
  width: 11rem;
}

@media screen and (min-width: 500px) {
  .name{
    padding: 2px 15px;
    font-size: 13px;
    margin-bottom: 18px;
  }

  .item img{
    max-width: 110px;
  }
}
</style>